(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hub-management', {
                parent: 'admin',
                url: '/hub-management',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'global.hub.stores-hub'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/hub-management.html',
                        controller: 'HubManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-type', {
                parent: 'hub-management',
                url: '/store-type',
                data: {
                    authorities: ['STORE_READ', 'ADMIN_MANAGE_SYSTEM'],
                    pageTitle: 'store-management.detail.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/store-type/store-type-list.html',
                        controller: 'StoreTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
